import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const allWatches = [
    {
        id: 1,
        name: 'Royal Oak Offshore',
        brand: 'Audemars Piguet',
        price: '$45,000',
        image: 'https://images.unsplash.com/photo-1547996663-b8558e6e3c9f?q=80&w=2070&auto=format&fit=crop',
        tag: 'Best Seller'
    },
    {
        id: 2,
        name: 'Nautilus 5711',
        brand: 'Patek Philippe',
        price: '$120,000',
        image: 'https://images.unsplash.com/photo-1614164185128-e48992479d80?q=80&w=1974&auto=format&fit=crop',
        tag: 'Limited'
    },
    {
        id: 3,
        name: 'Submariner Date',
        brand: 'Rolex',
        price: '$14,500',
        image: 'https://images.unsplash.com/photo-1526045431048-f857369baa09?q=80&w=2070&auto=format&fit=crop',
        tag: 'Classic'
    },
    {
        id: 4,
        name: 'Speedmaster Moonwatch',
        brand: 'Omega',
        price: '$7,600',
        image: 'https://images.unsplash.com/photo-1622434641406-a158123450f9?q=80&w=2008&auto=format&fit=crop',
        tag: 'Iconic'
    },
    {
        id: 5,
        name: 'Tank Must',
        brand: 'Cartier',
        price: '$3,450',
        image: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?q=80&w=1988&auto=format&fit=crop',
        tag: 'Elegant'
    },
    {
        id: 6,
        name: 'Big Bang Unico',
        brand: 'Hublot',
        price: '$22,000',
        image: 'https://images.unsplash.com/photo-1619134778706-7015533a6150?q=80&w=2070&auto=format&fit=crop',
        tag: 'Modern'
    }
];

const Collections = () => {
    return (
        <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="pt-32 pb-20 bg-luxury-blue min-h-screen"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-luxury-black mb-4">All Collections</h1>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Explore our complete range of precision timepieces, curated for the modern connoisseur.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {allWatches.map((watch) => (
                        <div key={watch.id} className="group relative">
                            <div className="glass-card rounded-xl overflow-hidden h-[500px] relative">
                                {/* Image */}
                                <img
                                    src={watch.image}
                                    alt={watch.name}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />

                                {/* Overlay Gradient */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />

                                {/* Content */}
                                <div className="absolute bottom-0 left-0 w-full p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-luxury-gold text-sm uppercase tracking-wider mb-1">{watch.brand}</p>
                                            <h3 className="text-2xl font-serif font-bold mb-2 text-white">{watch.name}</h3>
                                        </div>
                                        <div className="glass px-3 py-1 rounded-full flex items-center gap-1">
                                            <Star className="w-3 h-3 text-luxury-gold fill-luxury-gold" />
                                            <span className="text-xs text-white">{watch.tag}</span>
                                        </div>
                                    </div>

                                    <div className="flex justify-between items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                                        <span className="text-xl font-semibold text-white">{watch.price}</span>
                                        <button className="text-sm border-b border-luxury-gold pb-1 text-white hover:text-luxury-gold transition-colors">
                                            View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </motion.section>
    );
};

export default Collections;
